<template>
  <div>
    <div v-if="loading_base" class="loading-container">
      Loading...
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else class="demo-edit-config-struct">
      <!--<div class="logbook-info">
        
                <div class="logbook-header">
                    
                    <div class="status processes-status">
                        Processes<v-progress-circular v-if="loading_processes" indeterminate color="primary"></v-progress-circular><v-icon v-else color="green">mdi-check</v-icon>
                    </div>
                    <div class="status machines-status">
                        Machines<v-progress-circular v-if="loading_machines" indeterminate color="primary"></v-progress-circular><v-icon v-else color="green">mdi-check</v-icon>
                    </div>
                    <div class="status lines-status">
                        Lines<v-progress-circular v-if="loading_lines" indeterminate color="primary"></v-progress-circular><v-icon v-else color="green">mdi-check</v-icon>
                    </div>
                </div>
                -->

      <div class="logbook-info">
        <v-col cols="4" class="logbook-name">
          <v-typography style="letter-spacing: 5px"> {{ logbook.name }} </v-typography>
        </v-col>

        <div class="logbook-actions">
          <v-btn
            style="text-transform: capitalize; font-size: 12px"
            stacked
            variant="text"
            @click="viewLogbook(logbook.id)"
          >
            <span style="display: flex">
              <v-icon size="40" class="mb-2">mdi-eye</v-icon>
            </span>
            View Logbook
          </v-btn>

          <v-btn
            style="text-transform: capitalize; font-size: 12px"
            stacked
            variant="text"
            @click="editOrderMode = !editOrderMode"
          >
            <span style="display: flex">
              <v-icon size="40" class="mb-2">
                {{ editOrderMode ? "mdi-view-list-outline" : "mdi-view-list" }}
              </v-icon>
            </span>
            {{ editOrderMode ? "Disable Drag & Drop" : "Enable Drag & Drop" }}
          </v-btn>

          <v-btn
            v-if="editOrderMode"
            style="text-transform: capitalize; font-size: 12px"
            stacked
            variant="text"
            color="green"
            @click="updateLogbookOrder"
          >
            <span style="display: flex">
              <v-icon size="40" class="mb-2">mdi-check</v-icon>
            </span>
            Save Order
          </v-btn>
        </div>
      </div>

      <div class="logbook-sections">
        <div class="logbook-lookup">
          <draggable
            ghost-class="ghost"
            :disabled="!editOrderMode"
            v-model="groupedLines"
            @start="drag = true"
            @end="drag = false"
            item-key="id"
            class="process-group"
            @change="(e) => moveOrderPcReorder(e, groupedLines)"
          >
            <template #item="{ element }">
              <div>
                <h5 class="process-header">
                  {{ element.name }} [{{ element.fbs }}]

                  <v-btn
                    style="text-transform: capitalize; font-size: 12px"
                    stacked
                    variant="text"
                    @click="togglePcVisibility(element, element.custom_hide_view)"
                  >
                    <span style="display: flex">
                      <v-icon size="40" class="mb-2">{{ element.custom_hide_view ? "mdi-eye-off" : "mdi-eye" }}</v-icon>
                    </span>
                    {{ element.custom_hide_view ? "Show process" : "Hide process" }}
                  </v-btn>
                </h5>
                <draggable
                  ghost-class="ghost"
                  :disabled="!editOrderMode"
                  v-model="element.lines"
                  @start="drag = true"
                  @end="drag = false"
                  item-key="id"
                  @change="(e) => moveOrderLnsReorder(e, element.lines)"
                >
                  <template #item="{ element }">
                    <div class="line-entrée">
                      <div class="line-entry">
                        <v-checkbox @change="toggleLineInLogbook(element.id)"></v-checkbox>
                        <v-card-title>{{ element.name }} </v-card-title>
                        <v-card-subtitle> {{ element.product.name }} </v-card-subtitle>
                      </div>
                      <v-card class="custom-fields-section">
                        <v-card-title class="custom-fields-title">Line Custom Fields</v-card-title>
                        <v-card-text>
                          <div v-if="editOrderMode === false" class="custom-field-list">
                            <v-chip v-for="cf in element.combined_custom_fields" :key="cf.id" :class="!cf.global_type?'custom-field':'custom-field-global'">
                              {{ cf.name }}
                              <span class="custom-field-inner" v-if="cf.data_type === 'string'">Text</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'int'">Integer</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'float'">Decimal</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'bool'">Yes/No</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'datetime'">Date</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'percentage'">Percent</span>
                              <span class="custom-field-inner" v-else-if="cf.data_type === 'choices'">Option</span>
                              <span class="custom-field-inner" v-else>{{ cf.data_type }}</span>
                              <v-icon v-if="!cf.global_type" @click="openCustomFieldCopyModal(cf)">mdi-content-copy</v-icon>
                              <v-icon v-if="!cf.global_type" @click="openCustomFieldOptionsModal(cf)">mdi-cog</v-icon>
                              <v-icon v-if="!cf.global_type" @click="openCustomFieldRemovalModal(cf)">mdi-trash-can</v-icon>
                              <v-icon v-if="cf.global_type" @click="openStruct">mdi-earth</v-icon>
                            </v-chip>
                            <v-chip class="custom-field" @click="openAddCustomFieldModal(element.id)">
                              <v-icon left>mdi-plus</v-icon> Add custom field
                            </v-chip>
                          </div>

                          <div v-else>
                            <draggable
                              ghost-class="ghost"
                              :disabled="!editOrderMode"
                              v-model="element.combined_custom_fields"
                              @start="drag = true"
                              @end="drag = false"
                              item-key="id"
                              class="custom-field-list"
                              @change="(e) => moveOrderCfReorder(e, element.combined_custom_fields)"
                            >
                              <template #item="{ element }">
                                <v-chip>
                                  {{ element.name }}
                                  <span class="custom-field-inner" v-if="element.data_type === 'string'">Text</span>
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'int'"
                                    >Integer</span
                                  >
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'float'"
                                    >Decimal</span
                                  >
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'bool'"
                                    >Yes/No</span
                                  >
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'datetime'"
                                    >Date</span
                                  >
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'percentage'"
                                    >Percent</span
                                  >
                                  <span class="custom-field-inner" v-else-if="element.data_type === 'choices'"
                                    >Option</span
                                  >
                                </v-chip>
                              </template>
                            </draggable>
                          </div>
                        </v-card-text>
                      </v-card>
                      <v-card class="machine-section">
                        <v-card-title class="machine-title">Machines</v-card-title>
                        <v-card-text>
                          <draggable
                            v-if="element.showMachines"
                            :disabled="!editOrderMode"
                            ghost-class="ghost"
                            v-model="element.machines"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="id"
                            @change="(e) => moveOrderMcReorder(e, element.machines)"
                          >
                            <template #item="{ element }">
                              <div class="machine-row">
                                <v-chip>
                                  <v-icon @click="openMachineEdit(element)">mdi-cog</v-icon>
                                  <v-icon @click="removeMachineDialog(element)">mdi-trash-can</v-icon>
                                </v-chip>

                                <v-card-title>{{ element.name }}</v-card-title>
                                <v-card-subtitle>{{ element.fbs_id }}</v-card-subtitle>

                                <draggable
                                  class="custom-field-list"
                                  ghost-class="ghost"
                                  v-model="element.combined_custom_fields"
                                  :disabled="!editOrderMode"
                                  @start="drag = true"
                                  @end="drag = false"
                                  item-key="id"
                                  @change="(e) => moveOrderMcfReorder(e, element.combined_custom_fields)"
                                >
                                  <template #item="{ element }">
                                    <v-chip>
                                      {{ element.name }}
                                      <span class="custom-field-inner" v-if="element.data_type === 'string'">Text</span>
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'int'"
                                        >Integer</span
                                      >
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'float'"
                                        >Decimal</span
                                      >
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'bool'"
                                        >Yes/No</span
                                      >
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'datetime'"
                                        >Date</span
                                      >
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'percentage'"
                                        >Percent</span
                                      >
                                      <span class="custom-field-inner" v-else-if="element.data_type === 'choices'"
                                        >Option</span
                                      >
                                      <v-icon v-if="!editOrderMode" @click="openMachineCustomFieldCopyModal(element)"
                                        >mdi-content-copy</v-icon>
                                      <v-icon v-if="!editOrderMode" @click="openMachineCustomFieldOptionsModal(element)"
                                        >mdi-cog</v-icon>
                                      <v-icon v-if="!editOrderMode" @click="openMachineCustomFieldRemovalModal(element)"
                                        >mdi-trash-can</v-icon>
                                    </v-chip>
                                  </template>
                                </draggable>

                                <v-chip @click="openMachineCustomFieldAddModal(element)" class="custom-field">
                                  <v-icon>mdi-plus</v-icon> Add custom field
                                </v-chip>
                              </div>
                            </template>
                          </draggable>
                          <div v-if="element.machines.length > 0" class="margin-top:15px">
                            <v-btn v-if="element.showMachines" @click="openAddMachinesModal(element)"
                              >+ Add Machines</v-btn
                            >
                            <v-btn v-else @click="element.showMachines = true">Expand Machines</v-btn>
                            <v-btn v-if="element.showMachines" @click="element.showMachines = false"
                              >Collapse Machines</v-btn
                            >
                          </div>
                          <div v-else>
                            <v-btn @click="openAddMachinesModal(element)">+ Add Machines</v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </template>
                </draggable>
              </div>
            </template>
          </draggable>
          <v-btn
            @click="removeLinesFromLogbook()"
            :disabled="!linestoremove.length"
            color="black"
            style="
              margin-left: auto;
              display: flex;
              justify-content: center;
              height: 50px;
              font-size: 14px;
              width: 300px;
            "
            >Remove selected lines</v-btn
          >
        </div>

        <div class="logbook-lines">
          <h4>Quick Config</h4>
          <div v-if="!loading_lines">
            <v-autocomplete
              multiple
              v-model="selectedlines"
              :items="line_list.filter((line) => !logbook.lines.some((logbookLine) => logbookLine.id === line.id))"
              label="Select Line"
              item-title="name"
              item-value="id"
            ></v-autocomplete>
            <v-btn
              v-if="selectedlines.length === 1"
              @click="addLines"
              color="#006160"
              style="
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
                width: 300px;
                font-size: 14px;
                text-align: center;
              "
            >
              Add Line
            </v-btn>

            <v-btn
              v-else-if="selectedlines.length > 1"
              @click="addLines"
              color="#006160"
              style="
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
                width: 300px;
                font-size: 14px;
                text-align: center;
              "
              >Add Lines</v-btn
            >
            <div class="quick-create-section" style="background-color: lightblue">
              Quick create line
              <v-btn icon="mdi-plus" @click="showCreateLineModal = true"></v-btn>
            </div>
            <div class="quick-create-section" style="background-color: lightgray">
              Quick create product
              <v-btn icon="mdi-plus" @click="showCreateProductModal = true"></v-btn>
            </div>
          </div>
          <div v-else>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showCreateLineModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create New Line</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newLineName" placeholder="New Line Name"></v-text-field>
          <v-autocomplete
            v-model="selectedNewLineProcess"
            :items="process_list"
            label="Process"
            item-title="name"
            item-value="id"
          ></v-autocomplete>
          <v-autocomplete
            v-model="selectedNewLineProduct"
            :items="product_list"
            label="Product"
            item-title="name"
            item-value="id"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="createLine">Create</v-btn>
          <v-btn color="red" @click="showCreateLineModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showCustomFieldCopyModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Copy Custom Field</span>
        </v-card-title>
        <v-card-text>
          Where?
          <v-autocomplete v-model="selectedProcessCellsForCustomFieldCopy" multiple item-title="name" item-value="id" :items="logbookLines" label="Select Line"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="copyCustomField">Create</v-btn>
          <v-btn color="red" @click="closeCustomFieldCopyModal">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldCopyModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Copy Custom Field</span>
        </v-card-title>
        <v-card-text>
          Where?
          <v-autocomplete v-model="selectedMachinesForMachineCustomFieldCopy" multiple item-title="name" item-value="id" :items="getAllLogbookMachines()" label="Select Machines"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="copyMachineCustomField">Copy</v-btn>
          <v-btn color="red" @click="closeMachineCustomFieldCopyModal">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCustomFieldOptionsModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit/Configure Selected Custom field [{{ selectedCustomField.id }}]</span>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <div class="custom-field-options-row-container">
            <span>Edit name: </span>
            <input
              v-model="selectedCustomField.name"
              type="text"
              style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
            />
          </div>

          <v-divider></v-divider>
          <div class="custom-field-options-row-container">
            <span>Edit type: </span>
            <v-select
              v-model="selectedCustomField.data_type"
              dense
              :items="['string', 'int', 'float', 'bool', 'choices', 'datetime']"
            ></v-select>
          </div>

          <v-divider></v-divider>

          <div v-if="selectedCustomField.data_type === 'choices'" class="custom-field-options-container">
            <span>Edit Options</span>
            <v-chip
              v-for="choice in selectedCustomField.options"
              :key="choice.id"
              :class="{ 'custom-field': true, 'custom-field-loading': choice.loading }"
            >
              <p>{{ choice.value }}</p>
              <v-progress-circular v-if="choice.loading" indeterminate color="primary"></v-progress-circular>
              <v-icon v-else>mdi-delete</v-icon>
            </v-chip>
            <v-divider>
              <v-chip class="custom-field">
                <input
                  v-model="newCustomFieldTypeOption"
                  type="text"
                  style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
                />
                <v-icon @click="addCustomFieldTypeOption()" left>mdi-plus</v-icon> Add a choice
              </v-chip>
            </v-divider>
          </div>

          <v-divider></v-divider>
          <span>Edit Validations</span>* TODO
        </v-card-text>
        <v-card-actions>
          <v-btn color="lightgreen" @click="closeCustomFieldModal(true)">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="lightgray" @click="closeCustomFieldModal(false)">Discard</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldOptionsModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit/Configure Selected Custom field [{{ selectedMachineCustomField.id }}]</span>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <div class="custom-field-options-row-container">
            <span>Edit name: </span>
            <input
              v-model="selectedMachineCustomField.name"
              type="text"
              style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
            />
          </div>

          <v-divider></v-divider>
          <div class="custom-field-options-row-container">
            <span>Edit type: </span>
            <v-select
              v-model="selectedMachineCustomField.data_type"
              dense
              :items="['string', 'int', 'float', 'bool', 'choices', 'datetime']"
            ></v-select>
          </div>

          <v-divider></v-divider>

          <div v-if="selectedMachineCustomField.data_type === 'choices'" class="custom-field-options-container">
            <span>Edit Options</span>
            <v-chip
              v-for="choice in selectedMachineCustomField.options"
              :key="choice.id"
              :class="{ 'custom-field': true, 'custom-field-loading': choice.loading }"
            >
              <p>{{ choice.value }}</p>
              <v-progress-circular v-if="choice.loading" indeterminate color="primary"></v-progress-circular>
              <v-icon v-else>mdi-delete</v-icon>
            </v-chip>
            <v-divider>
              <v-chip class="custom-field">
                <input
                  v-model="newMachineCustomFieldTypeOption"
                  type="text"
                  style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
                />
                <v-icon @click="addMachineCustomFieldTypeOption()" left>mdi-plus</v-icon> Add a choice
              </v-chip>
            </v-divider>
          </div>

          <v-divider></v-divider>
          <span>Edit Validations</span>* TODO
        </v-card-text>
        <v-card-actions>
          <v-btn color="lightgreen" @click="closeMachineCustomFieldModal(true)">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="lightgray" @click="closeMachineCustomFieldModal(false)">Discard</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCreateProductModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create New Product</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newProductName" placeholder="New Product Name"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="newProduct">Create</v-btn>
          <v-btn color="red" @click="showCreateProductModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddCustomFieldModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Custom Field</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newCustomFieldName" placeholder="Custom Field Name"></v-text-field>
          <v-autocomplete
            v-model="selectedCustomFieldType"
            :items="['string', 'int', 'float', 'bool', 'datetime', 'percentage', 'choices']"
            label="Type"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="addCustomField">Add</v-btn>
          <v-btn color="red" @click="showAddCustomFieldModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddMachinesModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Machines to Line</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            multiple
            v-model="selectedMachines"
            :items="machine_list"
            label="Select Machines"
            item-title="name"
            item-value="id"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="addMachinesToLine">Add</v-btn>
          <v-btn color="red" @click="showAddMachinesModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineEditModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Machine - {{ selectedMachine.name }} </span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="selectedMachine.name" placeholder="Machine Name"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="saveMachine">ok</v-btn>
          <v-btn color="red" @click="showMachineEditModal = false">nok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCustomFieldRemovalModal" max-width="600px">
      <v-card>
        <v-card-title>Are You sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="removeCustomField">ok</v-btn>
          <v-btn color="red" @click="showCustomFieldRemovalModal = false">nok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineRemovalModal" max-width="600px">
      <v-card>
        <v-card-title>Are You sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="removeMachine">ok</v-btn>
          <v-btn
            color="red"
            @click="
              showMachineEditModal = false;
              selectedMachine.value = null;
            "
            >nok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldRemovalModal" max-width="600px">
      <v-card>
        <v-card-title>Are You sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="removeMachineCustomField">ok</v-btn>
          <v-btn color="red" @click="showMachineEditModal = false">nok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldEditModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Custom Field - {{ selectedMachineCustomField.name }} </span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="selectedMachineCustomField.name" placeholder="Custom Field Name"></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="closeMachineCustomFieldModal(true)">ok</v-btn>
          <v-btn color="red" @click="closeMachineCustomFieldModal(false)">nok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldRemoveModal" max-width="600px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="removeMachineCustomField">ok</v-btn>
          <v-btn color="red" @click="showMachineCustomFieldRemoveModal = false">nok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMachineCustomFieldAddModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add Machine Custom Field</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newMachineCustomFieldName" placeholder="Custom Field Name"></v-text-field>
          <v-autocomplete
            v-model="selectedMachineCustomFieldType"
            :items="['string', 'int', 'float', 'bool', 'datetime', 'percentage', 'choices']"
            label="Type"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="addMachineCustomField">Add</v-btn>
          <v-btn color="red" @click="showMachineCustomFieldAddModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right>
      {{ snackbar.message }}
      <v-btn color="white" text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import { onMounted } from "vue";
import axios from "axios";

import draggable from "vuedraggable";
import router from "@/router";

const logbook = ref([]);
const line_list = ref([]);
const process_list = ref([]);
const machine_list = ref([]);
const product_list = ref([]);
const groupedLines = ref([]);
const logbookLines = ref([]);
const loading_base = ref(true);
const loading_machines = ref(true);
const loading_lines = ref(true);
const loading_processes = ref(true);
const loading_products = ref(true);
const loading = ref(true);
const selectedlines = ref([]);
const selectedNewLineProcess = ref(null);
const selectedNewLineProduct = ref(null);
const selectedCustomField = ref(null);
const selectedMachine = ref(null);
const selectedProcessCellsForCustomFieldCopy = ref(null);
const selectedMachinesForMachineCustomFieldCopy = ref(null);
// const drag = ref(false);
const newLineName = ref("");
const newProductName = ref("");
const linestoremove = ref([]);
const showCreateLineModal = ref(false);
const showCreateProductModal = ref(false);
const showAddCustomFieldModal = ref(false);
const showCustomFieldOptionsModal = ref(false);
const showCustomFieldRemovalModal = ref(false);
const showAddMachinesModal = ref(false);
const showMachineEditModal = ref(false);
const showMachineRemovalModal = ref(false);
const showMachineCustomFieldEditModal = ref(false);
const showMachineCustomFieldRemoveModal = ref(false);
const showMachineCustomFieldOptionsModal = ref(false);
const showMachineCustomFieldAddModal = ref(false);
const showMachineCustomFieldRemovalModal = ref(false);
const showCustomFieldCopyModal = ref(false);
const showMachineCustomFieldCopyModal = ref(false);
const newMachineCustomFieldName = ref("");
const newMachineCustomFieldTypeOption = ref("");
const selectedMachineCustomFieldType = ref("");
const selectedMachineCustomField = ref(null);
const newCustomFieldName = ref("");
const newCustomFieldTypeOption = ref("");
const selectedCustomFieldType = ref("");
const historicalCustomField = ref("");
const historicalMachineCustomField = ref("");
const currentLineId = ref(null);
const selectedMachines = ref([]);
const snackbar = ref({
  show: false,
  message: "",
  color: "",
});
const editOrderMode = ref(false);

const props = defineProps({
  logbookid: {
    type: String,
    required: true,
  },
});

onMounted(() => {
  if (!props.logbookid) {
    console.error("No logbook id provided");
    return;
  }
  const prom0 = getLogbookInfo(props.logbookid)
    .then(() => {
      setTimeout(() => {
        loading_base.value = false;
      }, 1000);
      return true;
    })
    .catch((error) => {
      showSnackbar(error.data.detail, "error");
      return Error("Error loading logbook info");
    });

  const prom1 = getAllLines().then(() => {
    loading_lines.value = false;
  });
  const prom2 = getAllProcesses().then(() => {
    loading_processes.value = false;
  });
  const prom3 = getAllMachines().then(() => {
    loading_machines.value = false;
  });

  const prom4 = getAllProducts().then(() => {
    loading_products.value = false;
  });
  prom0.then(() => {
      Promise.all([prom1, prom2, prom3, prom4])
        .then(() => {
          loading.value = false;
          groupedLines.value = groupLines();
          logbookLines.value = groupedLines.value.map((obj) => obj.lines).flat()
          groupedLines.value.forEach((group) => {
            group.lines.sort((a, b) => logbook.value.ordering.lns[a.id] - logbook.value.ordering.lns[b.id]);
          });
        })
        .catch((error) => {
          console.error("Error fetching logbook info:", error);
          showSnackbar("Error fetching logbook infoasd", "error");
        });
    })
    .catch(() => {
      window.location.href = "#/logbooks-config";
    });
});
function openStruct(){
  window.open(`${window.origin}#/logbooks`,'_blank')
}

function addLines() {
    if (!selectedlines.value.length) {
        console.error('No line selected');
        return;
    }
    axios.post(`apiv1/${logbook.value.id}/add-line`, {
        lines: selectedlines.value
    }).then(response => {
        
        logbook.value.lines = response.data.lines
        selectedlines.value = [];
        showSnackbar('Line added successfully', 'success');
    }).catch(error => {
        console.error('Error adding line:', error);
        showSnackbar('Error adding line', 'error');
    });
}

function getAllLogbookMachines() {
  const machines = logbook.value.lines.map((line) => line.machines).flat()
  return machines
}

function viewLogbook() {
  if (!props.logbookid) {
    console.error("No logbook id provided");
    return;
  }
  window.location.href = `#/logbook/${props.logbookid}`;
}

async function getLogbookInfo(id) {
  await axios
    .get(`apiv1/${id}`)
    .then((response) => {
      logbook.value = response.data;
      for (let i = 0; i < logbook.value.lines.length; i++) {
        const cfs = logbook.value.lines[i].combined_custom_fields;
        logbook.value.lines[i].combined_custom_fields = refine_customfields(cfs);
      }
      return true;
    })
    .catch((e) => {
      console.error(e);
      showSnackbar("Error loading resources", "error");
      return e;
    });
}

async function getAllLines() {
  await axios
    .get("apiv1/alines")
    .then((response) => {
      line_list.value = response.data;
      return true;
    })
    .catch(() => {
      showSnackbar("Error loading resources", "error");
      return Error("Error loading resources");
    });
}

async function getAllProcesses() {
  await axios
    .get("apiv1/pc/pc-list")
    .then((response) => {
      process_list.value = response.data;
      return true;
    })
    .catch(() => {
      showSnackbar("Error loading resources", "error");
      return Error("Error loading resources");
    });
}

async function togglePcVisibility(pc, flag) {
  axios
    .patch("apiv1/pc/pc-vis", {
      id: pc.id,
      custom_hide_view: !flag,
    })
    .then(() => {
      pc.custom_hide_view = !flag;
      showSnackbar("Process visibility updated successfully", "success");
    })
    .catch((error) => {
      console.error("Error updating process visibility:", error);
      showSnackbar("Error updating process visibility", "error");
    });
}

async function getAllMachines() {
  await axios
    .get("apiv1/machines/list")
    .then((response) => {
      machine_list.value = response.data;
      return true;
    })
    .catch(() => {
      showSnackbar("Error loading resources", "error");
      return Error("Error loading resources");
    });
}

async function getAllProducts() {
  await axios
    .get("apiTEST/logbook/list-product")
    .then((response) => {
      product_list.value = response.data;
      return true;
    })
    .catch(() => {
      showSnackbar("Error loading resources", "error");
      return Error("Error loading resources");
    });
}

function toggleLineInLogbook(id) {
  if (linestoremove.value.includes(id)) {
    linestoremove.value = linestoremove.value.filter((x) => x !== id);
  } else {
    linestoremove.value.push(id);
  }
}

async function removeLinesFromLogbook() {
  await axios
    .post("apiTEST/logbook/remove", { logbook: Number(props.logbookid), lines: linestoremove.value })
    .then(() => {
      logbook.value.lines = logbook.value.lines.filter((line) => !linestoremove.value.includes(line.id));
      linestoremove.value = [];
      showSnackbar("Line removed successfully", "success");
      return true;
    })
    .catch((error) => {
      console.error("Error removing line from logbook:", error);
      showSnackbar("Error removing line from logbook", "error");
    });
}

function createLine() {
  if (!selectedNewLineProcess.value || !selectedNewLineProduct.value || !newLineName.value) {
    console.error("Missing data for new line");
    showSnackbar("Missing data for new line", "error");
    return;
  }
  axios
    .post("apiTEST/logbook/create-line", {
      name: newLineName.value,
      process_cell: selectedNewLineProcess.value,
      product: selectedNewLineProduct.value,
    })
    .then((response) => {
      logbook.value.lines.push(response.data);
      showCreateLineModal.value = false;
      showSnackbar("Line created successfully", "success");
    })
    .catch((error) => {
      console.error("Error creating line:", error);
      showSnackbar("Error creating line", "error");
    });
}

function newProduct() {
  axios
    .post("apiTEST/logbook/create-product", {
      name: newProductName.value,
      dnumber: 1337,
    })
    .then((response) => {
      product_list.value.push(response.data.product);
      showCreateProductModal.value = false;
      showSnackbar("Product created successfully", "success");
    })
    .catch((error) => {
      console.error("Error creating product:", error);
      showSnackbar("Error creating product", "error");
    });
}

function openAddCustomFieldModal(lineId) {
  currentLineId.value = lineId;
  showAddCustomFieldModal.value = true;
}

function closeCustomFieldModal(save) {
  if (save) {
    axios
      .patch(`apiv1/pcf/${selectedCustomField.value.id}/pcf-update`, { ...selectedCustomField.value, id: undefined })
      .then(() => {
        showSnackbar("Option added successfully", "success");
        showCustomFieldOptionsModal.value = false;
      })
      .catch((error) => {
        console.error("Error adding option:", error);
        showSnackbar("Error adding option", "error");
      });
    if (selectedCustomField.value.data_type !== "choices") {
      selectedCustomField.value.options = [];
    }
  } else {
    for (const key in historicalCustomField.value) {
      selectedCustomField.value[key] = historicalCustomField.value[key];
    }
    showCustomFieldOptionsModal.value = false;
  }
}

function addCustomField() {
  if (!newCustomFieldName.value || !selectedCustomFieldType.value) {
    showSnackbar("Please fill in all fields", "error");
    return;
  }
  axios
    .post("apiv1/pcf/pcf-add-demo", {
      is_global: false,
      process_cell: null,
      name: newCustomFieldName.value,
      logbook: logbook.value.id,
      line: currentLineId.value,
      type: selectedCustomFieldType.value,
    })
    .then((response) => {
      const line = logbook.value.lines.find((l) => l.id === currentLineId.value);
      if (line) {
        line.combined_custom_fields.push(response.data);
      }
      showAddCustomFieldModal.value = false;
      showSnackbar("Custom field added successfully", "success");
    })
    .catch((error) => {
      console.error("Error adding custom field:", error);
      showSnackbar("Error adding custom field", "error");
    });
}

function openAddMachinesModal(line) {
  currentLineId.value = line.id;
  showAddMachinesModal.value = true;
}

function openCustomFieldOptionsModal(customField) {
  selectedCustomField.value = customField;
  historicalCustomField.value = { ...customField };
  showCustomFieldOptionsModal.value = true;
}

function closeMachineCustomFieldModal(save) {
  if (save) {
    axios
      .patch(`apiv1/mcf/${selectedMachineCustomField.value.id}/mcf-update`, {
        ...selectedMachineCustomField.value,
        id: undefined,
      })
      .then(() => {
        showSnackbar("Option added successfully", "success");
        showCustomFieldOptionsModal.value = false;
      })
      .catch((error) => {
        console.error("Error adding option:", error);
        showSnackbar("Error adding option", "error");
      });
    if (selectedMachineCustomField.value.data_type !== "choices") {
      selectedMachineCustomField.value.options = [];
    }
  } else {
    for (const key in historicalMachineCustomField.value) {
      selectedMachineCustomField.value[key] = historicalMachineCustomField.value[key];
    }
    showMachineCustomFieldOptionsModal.value = false;
  }
}

function addMachinesToLine() {
  const line = logbook.value.lines.find((l) => l.id === currentLineId.value);
  if (!line) {
    console.error("Line not found");
    showSnackbar("Line not found", "error");
    return;
  }
  axios
    .post("apiv1/machines/mc-set-line", {
      line: currentLineId.value,
      machines: selectedMachines.value,
    })
    .then((response) => {
      line.machines = response.data;
      showSnackbar("Machines added successfully", "success");
      closeAddMachinesModal();

      router.go();
    })
    .catch((error) => {
      console.error("Error adding machines:", error);
      showSnackbar("Error adding machines", "error");
    });
}

function closeAddMachinesModal() {
  currentLineId.value = null;
  selectedMachines.value = [];
  showAddMachinesModal.value = false;
}

function showSnackbar(message, color) {
  snackbar.value.message = message;
  snackbar.value.color = color;
  snackbar.value.show = true;
}

function groupLines() {
  const groups = {};
  if (!logbook.value.lines) {
    return [];
  }
  logbook.value.lines.forEach((line) => {
    const processId = line.process_cell.id;
    if (!groups[processId]) {
      groups[processId] = {
        id: processId,
        name: line.process_cell.name,
        fbs: line.process_cell.fbs_id,
        lines: [],
        custom_hide_view: line.process_cell.custom_hide_view,
        order:
          logbook.value.ordering.pc[processId] != undefined
            ? logbook.value.ordering.pc[processId]
            : Math.max(...Object.values(logbook.value.ordering.pc), 0) + 1,
      };
      logbook.value.ordering.pc[processId] = groups[processId].order;
    }
    line.machines = line.machines.map((machine) => {
      const machineId = machine.id;
      const machineData = machine_list.value.find((m) => m.id === machineId);
      if (machineData) {
        machine.name = machineData.name;
        machine.fbs_id = machineData.fbs_id;
        machine.combined_custom_fields.sort(
          (a, b) => logbook.value.ordering.mcf[a.id] - logbook.value.ordering.mcf[b.id]
        );
      }
      return machine;
    });
    line.machines.sort((a, b) => logbook.value.ordering.mc[a.id] - logbook.value.ordering.mc[b.id]);
    groups[processId].lines.push(line);
  });
  return Object.values(groups).toSorted((a, b) => a.order - b.order);
}

function refine_customfields(custom_fields) {
  if (custom_fields == undefined) {
    return [];
  }
  custom_fields.map((cf) => {
    if (logbook.value.ordering.cf[cf.id] != undefined) {
      cf.order = logbook.value.ordering.cf[cf.id];
    } else {
      logbook.value.ordering.cf[cf.id] = Math.max(...Object.values(logbook.value.ordering.cf), 0) + 1;
      cf.order = 0;
    }
  });
  custom_fields.sort((a, b) => a.order - b.order);
  return custom_fields;
}

function addCustomFieldTypeOption() {
  if (!newCustomFieldTypeOption.value) {
    showSnackbar("Please fill in all fields", "error");
    return;
  }
  let boi = { value: newCustomFieldTypeOption.value, loading: true, id: "TEMP" };
  selectedCustomField.value.options.push(boi);

  axios
    .post("apiv1/pcf/pcf-add-option", {
      pcf: selectedCustomField.value.id,
      option: newCustomFieldTypeOption.value,
    })
    .then((response) => {
      showSnackbar("Option added successfully", "success");
      selectedCustomField.value.options.find((option) => option.id === "TEMP").loading = false;
      selectedCustomField.value.options.find((option) => option.id === "TEMP").id = response.data.id;
      newCustomFieldTypeOption.value = "";
    })
    .catch((error) => {
      console.error("Error adding option:", error);
      selectedCustomField.value.options = selectedCustomField.value.options.filter((option) => option.id !== boi.id);
      showSnackbar("Error adding option", "error");
    });
}

function moveOrderPcReorder(event, pcs) {
  pcs.forEach((pc, index) => {
    logbook.value.ordering.pc[pc.id] = index;
  });
}

function moveOrderCfReorder(event, cfs) {
  cfs.forEach((cf, index) => {
    logbook.value.ordering.cf[cf.id] = index;
  });
}

function moveOrderLnsReorder(event, lns) {
  lns.forEach((ln, index) => {
    logbook.value.ordering.lns[ln.id] = index;
  });
}

function moveOrderMcReorder(event, mcs) {
  mcs.forEach((mc, index) => {
    logbook.value.ordering.mc[mc.id] = index;
  });
}

function moveOrderMcfReorder(event, mcfs) {
  mcfs.forEach((mcfx, index) => {
    logbook.value.ordering.mcf[mcfx.id] = index;
  });
}

function updateLogbookOrder() {
  axios
    .post(`apiv1/set-order`, {
      logbook: logbook.value.id,
      ordering: logbook.value.ordering,
    })
    .then(() => {
      editOrderMode.value = false;
      showSnackbar("Order updated successfully", "success");
    })
    .catch((error) => {
      console.error("Error updating order:", error);
      showSnackbar("Error updating order", "error");
    });
}

function openMachineCustomFieldAddModal(machine) {
  selectedMachine.value = machine;
  showMachineCustomFieldAddModal.value = true;
}

function openMachineEdit(machine) {
  showMachineEditModal.value = true;
  selectedMachine.value = machine;
}

function removeMachineDialog(machine) {
  showMachineRemovalModal.value = true;
  selectedMachine.value = machine;
}

function addMachineCustomField() {
  if (!newMachineCustomFieldName.value || !selectedMachineCustomFieldType.value) {
    showSnackbar("Please fill in all fields", "error");
    return;
  }
  axios
    .post("apiv1/mcf/mcf-add-demo", {
      is_global: false,
      name: newMachineCustomFieldName.value,
      logbook: logbook.value.id,
      machine: selectedMachine.value.id,
      type: selectedMachineCustomFieldType.value,
    })
    .then((response) => {
      const machine = selectedMachine.value;
      if (machine) {
        machine.combined_custom_fields.push(response.data);
      }
      showMachineCustomFieldAddModal.value = false;
      showSnackbar("Custom field added successfully", "success");
    })
    .catch((error) => {
      console.error("Error adding custom field:", error);
      showSnackbar("Error adding custom field", "error");
    });
}

function saveMachine() {
  axios
    .patch(`apiv1/machines/${selectedMachine.value.id}/mc-update`, {
      name: selectedMachine.value.name,
    })
    .then(() => {
      showSnackbar("Machine updated successfully", "success");
      showMachineEditModal.value = false;
    })
    .catch((error) => {
      console.error("Error updating machine:", error);
      showSnackbar("Error updating machine", "error");
    });
}

function removeMachineCustomField() {
  axios
    .delete(`apiv1/mcf/${selectedMachineCustomField.value.id}/mcf-delete`, {})
    .then(() => {
      groupedLines.value.forEach((group) => {
        group.lines.forEach((line) => {
          line.machines.forEach((machine) => {
            machine.combined_custom_fields = machine.combined_custom_fields.filter(
              (cf) => cf.id !== selectedMachineCustomField.value.id
            );
          });
        });
      });
      showMachineCustomFieldRemovalModal.value = false;
      showSnackbar("Machine Custom Field removed successfully", "success");
    })
    .catch((error) => {
      console.error("Error removing machine custom field:", error);
      showSnackbar("Error removing machine custom field", "error");
    });
}

function openMachineCustomFieldRemovalModal(machineCustomField) {
  selectedMachineCustomField.value = machineCustomField;
  showMachineCustomFieldRemovalModal.value = true;
}


function openMachineCustomFieldOptionsModal(customField) {
  selectedMachineCustomField.value = customField;
  historicalMachineCustomField.value = { ...customField };
  showMachineCustomFieldOptionsModal.value = true;
}



function removeMachine() {
  axios
    .post(`apiv1/machines/${selectedMachine.value.id}/mc-nolla`, {})
    .then(() => {
      logbook.value.lines.forEach((line) => {
        line.machines = line.machines.filter((machine) => machine.id !== selectedMachine.value.id);
      });
      showSnackbar("Machine removed successfully", "success");
      showMachineRemovalModal.value = false;
      showMachineEditModal.value = false;
    })
    .catch((error) => {
      console.error("Error removing machine:", error);
      showSnackbar("Error removing machine", "error");
    });
}

function addMachineCustomFieldTypeOption() {
  console.log(selectedMachineCustomField.value);
  if (!newMachineCustomFieldTypeOption.value) {
    showSnackbar("Please fill in all fields", "error");
    return;
  }
  const boi = { value: newMachineCustomFieldTypeOption.value, loading: true, id: "TEMP" };
  selectedMachineCustomField.value.options.push(boi);

  axios
    .post("apiv1/mcf/mcf-add-option", {
      mcf: selectedMachineCustomField.value.id,
      option: newMachineCustomFieldTypeOption.value,
    })
    .then((response) => {
      showSnackbar("Option added successfully", "success");
      selectedMachineCustomField.value.options.find((option) => option.id === "TEMP").loading = false;
      selectedMachineCustomField.value.options.find((option) => option.id === "TEMP").id = response.data.id;
      newMachineCustomFieldTypeOption.value = "";
    })
    .catch((error) => {
      console.error("Error adding option:", error);
      selectedMachineCustomField.value.options = selectedMachineCustomField.value.options.filter(
        (option) => option.id !== boi.id
      );
      showSnackbar("Error adding option", "error");
    });
}

function openCustomFieldRemovalModal(customField) {
  selectedCustomField.value = customField;
  showCustomFieldRemovalModal.value = true;
}

function removeCustomField() {
  axios
    .delete(`apiv1/pcf/${selectedCustomField.value.id}/pcf-delete`, {})
    .then(() => {
      logbook.value.lines.forEach((line) => {
        line.combined_custom_fields = line.combined_custom_fields.filter(
          (cf) => cf.id !== selectedCustomField.value.id
        );
      });
      showSnackbar("Custom Field removed successfully", "success");
      showCustomFieldRemovalModal.value = false;
    })
    .catch((error) => {
      console.error("Error removing custom field:", error);
      showSnackbar("Error removing custom field", "error");
    });

  }
  function openCustomFieldCopyModal(customField) {
    selectedCustomField.value = customField;
    showCustomFieldCopyModal.value = true;
  }

  function openMachineCustomFieldCopyModal(machineCustomField) {
    selectedMachineCustomField.value = machineCustomField;
    showMachineCustomFieldCopyModal.value = true;
  }

  function closeCustomFieldCopyModal() {
    showCustomFieldCopyModal.value = false;
    selectedCustomField.value = null;
    selectedProcessCellsForCustomFieldCopy.value = [];
  }

  function closeMachineCustomFieldCopyModal() {
    selectedMachineCustomField.value = null;
    showMachineCustomFieldCopyModal.value = false;
    selectedMachinesForMachineCustomFieldCopy.value = [];
  }

function copyCustomField(){
  console.log(selectedProcessCellsForCustomFieldCopy.value);
  if (!selectedProcessCellsForCustomFieldCopy.value.length) {
    console.error('No line selected');
    return;
  }
  axios.post(`apiv1/pcf/pcf-copy`, {
    logbook: logbook.value.id,
    lines: selectedProcessCellsForCustomFieldCopy.value,
    pcf: selectedCustomField.value.id
  }).then(response => {
    logbook.value.lines.forEach(line => {
      const logbookline = logbook.value.logbooklines.find(l => l.line === line.id);
      for (const pcf of response.data) {
          if (pcf.process_cell_line === logbookline.id) {
            line.combined_custom_fields.push(pcf);
          }
      }
    });
    showSnackbar('Custom Field copied successfully', 'success');
  }).catch(error => {
    console.error('Error copying custom field:', error);
    showSnackbar('Error copying custom field', 'error');
  });
  closeCustomFieldCopyModal();
  
}

function copyMachineCustomField(){
  if (!selectedMachinesForMachineCustomFieldCopy.value.length) {
    console.error('No line selected');
    return;
  }
  axios.post(`apiv1/mcf/mcf-copy`, {
    logbook: logbook.value.id,
    mcf: selectedMachineCustomField.value.id,
    machines: selectedMachinesForMachineCustomFieldCopy.value
  }).then(response => {
    logbook.value.lines.forEach(line => {
      line.machines.forEach(machine => {
        for (const mcf of response.data) {
          if (mcf.machine === machine.id) {
            machine.combined_custom_fields.push(mcf);
          }
        }
      });
    });
    showSnackbar('Machine Custom Field copied successfully', 'success');
  }).catch(error => {
    console.error('Error copying machine custom field:', error);
    showSnackbar('Error copying machine custom field', 'error');
  });
  closeMachineCustomFieldCopyModal();
}




</script>

<style scoped>
.ghost {
  opacity: 0.5;
  border: #00796b 3px dashed;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.demo-edit-config-struct {
  margin: auto;
  max-width: 1440px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

p {
  font-size: 14px;
  margin: 2px 0;
}

.logbook-info {
  background-color: #f5f5f5;
  padding: 10px; /* Reduced padding to lower height */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between; /* Aligns name and buttons properly */
  gap: 10px; /* Adds some space between elements */
}

.logbook-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.logbook-info h3 {
  margin: 0;
  color: #333333;
  flex-grow: 1; /* Allows it to take up remaining space */
  text-align: center; /* Centers the logbook name */
}

.logbook-info p {
  margin: 2px 0;
  color: #555555;
}

/* Ensure buttons and text align */
.logbook-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status {
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.status v-icon {
  margin-left: 5px;
}

.logbook-sections {
  margin-top: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.logbook-lookup,
.logbook-lines {
  margin-bottom: 20px;
}

.logbook-line-row,
.logbook-machine {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #e0e0e0;
}

.line-entry {
  display: flex;
  align-items: center; /* Align items vertically */
  gap: 10px; /* Add spacing between elements */
}

.line-text {
  display: flex;
  flex-direction: column; /* Stack title and subtitle */
}

.custom-field {
  padding: 5px;
  border-radius: 16px;
  background-color: #b2ebf2;
  display: inline-flex;
  align-items: center;
  margin: 2px;
}

.custom-field-global {
  padding: 5px;
  border-radius: 16px;
  background-color: #b8f8d3;
  display: inline-flex;
  align-items: center;
  margin: 2px;
}

.custom-fields-section {
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f9f9f9;
}

.custom-fields-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}
.custom-field-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.v-btn {
  margin-left: 5px;
}

.v-autocomplete,
.v-text-field {
  margin: 5px;
}

.custom-field-inner {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 16px;
  background-color: #00796b;
  margin-left: 5px;
  font-size: 12px;
  color: #ffffff;
}

.quick-create-section {
  display: flex;
  flex-direction: row;
  padding: 10px;
  border-radius: 8px;
  margin: 20px;
  align-items: center;
}

.process-group {
  margin-bottom: 20px;
}

.process-header {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  background-color: #e2e2e2;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.custom-field-options-row-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 2px;
}

.machine-expansion-panel {
  margin-top: 10px;
}

.line-entrée {
  margin-bottom: 10px;
  padding: 10px;
}

.machine-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #e0e0e0;
}
.machine-section {
  margin-top: 20px; /* Adds space above */
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f9f9f9; /* Light background */
}

.machine-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
